// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"Optins_pageHeader__2qAj1"};